import { combineReducers } from 'redux';

import user from './user/reducer';
import orders from './orders/reducer';
import instantExchangeOrders from './instantExchange/reducer';
import userHotTransactions from './transactions/reducer';
import wallets from './wallets/reducer';
import margin from './margin/reducer';
import loginHistory from './loginHistory/reducer';
import userSecurity from './security/reducer';

export default combineReducers({
  user,
  instantExchangeOrders,
  orders,
  wallets,
  margin,
  userHotTransactions,
  loginHistory,
  userSecurity,
});
